module.exports = __webpack_public_path__ + "static/media/popular_Questions.2b8e0ebf.png";